import styled from '@emotion/styled';
import { BREAKPOINTS, mediaQuery, responsiveFontSize } from '@presentation/styles';

export const Wrapper = styled.div`
  box-shadow: -1px 3px 16px rgba(149, 157, 165, 0.19);
  padding: 40px 32px;
  position: relative;
`;

export const ImageWrapper = styled.div`
  margin-top: 24px;
`;

export const Title = styled.div`
  margin-top: 24px;
  ${responsiveFontSize(24, 1)};
  font-weight: 700;
  color: ${(props) => props.theme.color.dark.shade};
`;

export const Text = styled.div`
  margin-top: 20px;
  ${responsiveFontSize(16, 0.5)};
`;

export const Bubble = styled.div`
  position: absolute;
  top: -136px;
  right: -80px;

  ${mediaQuery(BREAKPOINTS.tablet)} {
    display: none;
  }
`;
